import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  user_company_details,
  user_institutions_detail,
  user_resource_detail,
  user_expert_detail,
  user_get_pplication,
  user_get_candidate_details,
  user_get_vendor_detail,
  studentProfileDetail,
  internshipQualifications,
  add_financial_record,
  update_financial_record,
  upload_application_logo,
  upload_company_logo,
} from "../../../user.api";
import { getInternshipOpportunities } from "../../../../public/public.api";
import ReactHtmlParser from "react-html-parser";
import CustomTable from "../../../../../components/table/table";
import moment from "moment";
import Swal from "sweetalert2";
import jwtDecode from "jwt-decode";
import CustomIcons from "../../../../../components/icons/kIcons.component";

const DashProfileDetails = (props) => {
  const history = useHistory();
  const [data, setData] = useState({});
  const userId = props?.data?.user_id;
  const id = props?.data?.id;
  const userRole = props?.userType;
  const [loading, setLoading] = useState(true);

  const activeStatus = (statusId) => {
    const status = Number(statusId);
    if (status === 0) return "Pending";
    if (status === 1) return "Submitted for Acceptance";
    if (status === 2) return "Approved";
    if (status === 3) return "Super Admin Reverted";
    if (status === 4) return "Rejected";
    if (status === 5) return "Reverted";
    return "";
  };

  const hasValue = (value) => {
    return (
      value !== null && value !== undefined && value !== "" && value !== "null"
    );
  };

  const loadData = async (isMounted = true) => {
    let isReady = false;
    if (props?.companyData?.is_company_user) {
      if (props?.companyData?.parent_company?.company_type === "application") {
        isReady = true;
      } else if (userId) {
        isReady = true;
      }
    } else if (userRole !== undefined && userRole !== null) {
      const roleNum = Number(userRole);
      if ([5, 6, 9, 10].includes(roleNum)) {
        isReady = !!userId;
      } else if ([8, 20].includes(roleNum)) {
        isReady = !!id;
      } else if (roleNum === 24) {
        isReady = !!props?.userDetails?.user?.id;
      } else if ([4, 0, 27].includes(roleNum)) {
        isReady = true;
      }
    }

    if (!isReady) return;

    try {
      setLoading(true);
      if (props?.companyData?.is_company_user) {
        let res;
        if (
          props?.companyData?.parent_company?.company_type === "application"
        ) {
          res = await user_get_pplication();
        } else {
          res = await user_company_details(userId);
        }
        if (isMounted) setData(res?.data);
        setLoading(false);
        return;
      }

      const roleNum = Number(userRole);
      if (roleNum === 5 || roleNum === 6) {
        const res = await user_company_details(userId);
        if (isMounted) setData(res?.data);
      } else if (roleNum === 8) {
        const res = await user_institutions_detail(id);
        if (isMounted) setData(res?.data);
      } else if (roleNum === 9) {
        const res = await user_resource_detail(userId);
        if (isMounted) setData(res?.data[0]);
      } else if (roleNum === 10) {
        const res = await user_expert_detail(userId);
        if (isMounted) setData(res?.data[0]);
      } else if (roleNum === 4 || roleNum === 0) {
        const res = await user_get_pplication();
        if (isMounted) setData(res.data);
      } else if (roleNum === 24) {
        const res = await user_get_vendor_detail(props?.userDetails?.user?.id);
        if (isMounted) setData(res.data);
      } else if (roleNum === 20) {
        const res = await user_get_candidate_details(id);
        if (isMounted) setData(res.data);
      } else if (roleNum === 27) {
        const [studentRes, qualRes, oppRes] = await Promise.all([
          studentProfileDetail(),
          internshipQualifications(),
          getInternshipOpportunities()
        ]);
        if (isMounted) {
          setData({
            ...studentRes?.data,
            qualificationsData: qualRes?.data || qualRes?.data?.data || [],
            internshipOpportunities: oppRes?.data || oppRes?.data?.data || []
          });
        }
      }
    } catch (e) {
      console.error("Error loading profile details:", e);
    } finally {
      if (isMounted) setLoading(false);
    }
  };

  useEffect(() => {
    let mounted = true;
    loadData(mounted);
    return () => {
      mounted = false;
    };
  }, [props?.data, props?.userType, props?.companyData, props?.userDetails]);

  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);

  const getFileUrl = (filePath) => {
    if (!filePath) return "";
    if (filePath.startsWith("http")) return filePath;
    let base = result;
    if (base.endsWith("/")) {
      base = base.slice(0, -1);
    }
    let subPath = filePath;
    if (subPath.startsWith("/")) {
      subPath = subPath.slice(1);
    }
    return `${base}/${subPath}`;
  };

  const fileDownload = (filePath) => {
    let url = getFileUrl(filePath);
    window.open(url, "_blank");
  };

  const fullfileDownload = (filePath) => {
    let url = getFileUrl(filePath);
    window.open(url, "_blank");
  };

  const handleTableDownload = (item) => {
    const file = item?.file_upload_certificate || item?.edu_certificate || item?.experience_certificate || item?.certificate_photo || item?.exp_certificate;
    if (file) {
      fullfileDownload(file);
    }
  };

  const handleUploadLogo = async () => {
    if (!data?.id) return;
    const { value: confirmed } = await Swal.fire({
      title: "Upload Logo",
      html:
        '<input id="swal-logo" type="file" class="swal2-file" accept=".jpg,.jpeg,.png" />' +
        '<div class="text-muted" style="font-size:12px;margin-top:6px;">Allowed: JPG/JPEG/PNG</div>',
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Upload",
      confirmButtonColor: "#0A223D",
      preConfirm: () => {
        const fileInput = document.getElementById("swal-logo");
        const file = fileInput && fileInput.files && fileInput.files[0];
        if (!file) {
          Swal.showValidationMessage("Please choose a logo file");
          return false;
        }
        const validTypes = ["image/jpeg", "image/png", "image/jpg"];
        if (!validTypes.includes(file.type)) {
          Swal.showValidationMessage(
            "Invalid file type. Please upload JPG or PNG"
          );
          return false;
        }
        return file;
      },
    });

    if (confirmed) {
      try {
        const fileInput = document.getElementById("swal-logo");
        const file = fileInput.files[0];
        const form = new FormData();
        form.append("logo", file);
        if (Number(userRole) === 0) {
          await upload_application_logo(data.id, form);
        } else {
          await upload_company_logo(data.user_id, form);
        }
        if ([0, 4, 5, 6].includes(Number(userRole))) {
          loadData(true);
        } else {
          setData((prev) => ({ ...prev, logo: "uploaded" }));
        }
        Swal.fire({ icon: "success", title: "Logo uploaded" });
      } catch (e) {
        Swal.fire({
          icon: "error",
          title: "Upload failed",
          text: e?.message || "",
        });
      }
    }
  };

  const handleDownloadExpCert = (filePath) => {
    let path = getFileUrl(filePath);
    window.open(path, "_blank");
  };

  const handleAddFinancialRecord = async () => {
    if (!data?.id) return;
    const now = new Date();
    const currYear = now.getFullYear();
    const fyOptions = [];
    const startYear = 2024;
    const existingYears =
      data?.financial_records?.map((record) => record.financial_year) || [];

    for (let i = startYear; i <= currYear; i++) {
      const fyOption = `${i}-${i + 1}`;
      if (!existingYears.includes(fyOption)) {
        fyOptions.push(`<option value="${fyOption}">${fyOption}</option>`);
      }
    }

    const { value: formValues } = await Swal.fire({
      title: `<span style="font-size: 18px;">${data?.company_status === "existing_company" && data?.company_type === "kerala" ? "Add Records" : "Add Financial Record"}</span>`,
      width: "700px",
      html:
        '<div class="form-group mb-2">' +
        '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">Financial Year <span style="color: red;">*</span></label>' +
        '<select id="swal-year" class="form-select" style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">' +
        fyOptions.join("") +
        "</select>" +
        "</div>" +
        '<div class="form-group mb-2">' +
        '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">FY Turnover (in Crores) <span style="color: red;">*</span></label>' +
        '<input id="swal-turnover" type="number" step="0.01" class="form-control" placeholder="Enter turnover in crores" ' +
        "oninput=\"this.value = this.value.replace(/[^0-9]/g, '').slice(0, 6);\" " +
        'style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da; margin-bottom: 20px;">' +
        "</div>" +
        (data?.company_status === "existing_company" &&
          data?.company_type === "kerala"
          ? '<div class="form-group mb-2">' +
          '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">Remark</label>' +
          '<input id="swal-remark" type="text" class="form-control" placeholder="Enter remark" style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">' +
          "</div>"
          : "") +
        (data?.company_status === "existing_company" &&
          data?.company_type === "kerala"
          ? '<div class="form-group mb-3">' +
          '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">Capital Investment (in Crores)</label>' +
          '<input id="swal-capital" type="number" step="0.01" class="form-control" placeholder="Enter capital investment in crores" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').slice(0, 6);" style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">' +
          "</div>" +
          '<div class="form-group mb-2">' +
          '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">Male <span style="color: red;">*</span></label>' +
          '<input id="swal-male" type="number" class="form-control" placeholder="Enter male count" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').slice(0, 6);" style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">' +
          "</div>" +
          '<div class="form-group mb-2">' +
          '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">Female <span style="color: red;">*</span></label>' +
          '<input id="swal-female" type="number" class="form-control" placeholder="Enter female count" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').slice(0, 6);" style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">' +
          "</div>" +
          '<div class="form-group mb-2">' +
          '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">Genderqueer <span style="color: red;">*</span></label>' +
          '<input id="swal-genderqueer" type="number" class="form-control" placeholder="Enter genderqueer count" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').slice(0, 6);" style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">' +
          "</div>" +
          '<div class="form-group mb-2">' +
          '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">SC/ST <span style="color: red;">*</span></label>' +
          '<input id="swal-scst" type="number" class="form-control" placeholder="Enter SC/ST count" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').slice(0, 6);" style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">' +
          "</div>" +
          '<div class="form-group mb-3">' +
          '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">PWD <span style="color: red;">*</span></label>' +
          '<input id="swal-pwd" type="number" class="form-control" placeholder="Enter PWD count" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').slice(0, 6);" style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">' +
          "</div>"
          : ""),
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Save",
      confirmButtonColor: "#0A223D",
      cancelButtonColor: "#6c757d",
      didOpen: (el) => {
        const confirmBtn = document.querySelector(".swal2-confirm");
        const cancelBtn = document.querySelector(".swal2-cancel");
        if (confirmBtn) confirmBtn.style.minWidth = "120px";
        if (cancelBtn) cancelBtn.style.minWidth = "120px";

        if (data?.company_status === "existing_company" && el) {
          el.style.height = "auto";
          const htmlContainer = el.querySelector(".swal2-html-container");
          if (htmlContainer) {
            htmlContainer.style.maxHeight = "60vh";
            htmlContainer.style.overflowY = "auto";
          }
        }
      },
      preConfirm: () => {
        const year = (document.getElementById("swal-year").value || "").trim();
        const turnover = document.getElementById("swal-turnover").value;

        if (!year) {
          Swal.showValidationMessage("Please select a financial year");
          return false;
        }
        if (!turnover) {
          Swal.showValidationMessage("Please enter turnover");
          return false;
        }

        const turnoverParts = String(turnover).split(".");
        if (turnoverParts[0] && turnoverParts[0].length > 6) {
          Swal.showValidationMessage("Turnover cannot exceed 6 digits");
          return false;
        }

        const formValues = {
          financial_year: year,
          fy_turnover: turnover,
        };

        if (
          data?.company_status === "existing_company" &&
          data?.company_type === "kerala"
        ) {
          const male = document.getElementById("swal-male")?.value || "";
          const female = document.getElementById("swal-female")?.value || "";
          const genderqueer =
            document.getElementById("swal-genderqueer")?.value || "";
          const sc_st = document.getElementById("swal-scst")?.value || "";
          const pwd = document.getElementById("swal-pwd")?.value || "";

          if (!male || !female || !genderqueer || !sc_st || !pwd) {
            Swal.showValidationMessage(
              "Please fill all employment fields (Male, Female, Genderqueer, SC/ST, PWD)"
            );
            return false;
          }

          const employmentFields = [
            { label: "Male", value: String(male) },
            { label: "Female", value: String(female) },
            { label: "Genderqueer", value: String(genderqueer) },
            { label: "SC/ST", value: String(sc_st) },
            { label: "PWD", value: String(pwd) },
          ];
          const tooLong = employmentFields.find(
            (f) => f.value.replace(/[^0-9]/g, "").length > 6
          );
          if (tooLong) {
            Swal.showValidationMessage(
              `${tooLong.label} cannot exceed 6 digits`
            );
            return false;
          }

          const capitalInvestment =
            document.getElementById("swal-capital")?.value || "";
          if (capitalInvestment) {
            const capitalParts = String(capitalInvestment).split(".");
            if (capitalParts[0] && capitalParts[0].length > 6) {
              Swal.showValidationMessage(
                "Capital investment cannot exceed 6 digits"
              );
              return false;
            }
          }

          formValues.capital_investment = capitalInvestment;
          formValues.remarks = (
            document.getElementById("swal-remark")?.value || ""
          ).trim();
          formValues.dir_employ_male = male;
          formValues.dir_employ_female = female;
          formValues.dir_employ_others = genderqueer;
          formValues.dir_employ_sc_st = sc_st;
          formValues.dir_employ_pwd = pwd;
        }

        return formValues;
      },
    });

    if (formValues) {
      try {
        await add_financial_record(data.id, formValues);
        loadData(true);
        Swal.fire({ icon: "success", title: "Saved" });
      } catch (e) {
        const errorMsg =
          e?.response?.data?.message || e?.message || "Failed to save";
        Swal.fire({ icon: "error", title: "Failed to save", text: errorMsg });
      }
    }
  };

  const handleEditFinancialRecord = async (row) => {
    if (!data?.id) return;
    const { value: formValues } = await Swal.fire({
      title: '<span style="font-size: 18px;">Edit Financial Record</span>',
      width: "700px",
      html:
        '<div class="form-group mb-2">' +
        '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">Financial Year<span style="color: red;">*</span></label>' +
        `<input id="swal-year" class="form-control" value="${row.financial_year || ""}" disabled style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da; background-color: #f8f9fa;margin-bottom: 20px;">` +
        "</div>" +
        '<div class="form-group mb-2">' +
        '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">FY Turnover (in Crores) <span style="color: red;">*</span></label>' +
        `<input id="swal-turnover" type="number" step="0.01" class="form-control" placeholder="Enter turnover in crores" value="${row.fy_turnover || ""}" ` +
        'style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da; margin-bottom: 20px;">' +
        "</div>" +
        (data?.company_status === "existing_company" &&
          data?.company_type === "kerala"
          ? '<div class="form-group mb-2">' +
          '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">Remark</label>' +
          `<input id="swal-remark" type="text" class="form-control" placeholder="Enter remark" value="${row.remarks || ""}" style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">` +
          "</div>"
          : "") +
        (data?.company_status === "existing_company" &&
          data?.company_type === "kerala"
          ? '<div class="form-group mb-3">' +
          '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">Capital Investment (in Crores)</label>' +
          `<input id="swal-capital" type="number" step="0.01" class="form-control" placeholder="Enter capital investment in crores" value="${row.capital_investment || ""}" ` +
          'style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">' +
          "</div>"
          : ""),
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Update",
      confirmButtonColor: "#0A223D",
      cancelButtonColor: "#6c757d",
      didOpen: () => {
        const confirmBtn = document.querySelector(".swal2-confirm");
        const cancelBtn = document.querySelector(".swal2-cancel");
        if (confirmBtn) confirmBtn.style.minWidth = "120px";
        if (cancelBtn) cancelBtn.style.minWidth = "120px";

        const turnoverInput = document.getElementById("swal-turnover");
        if (turnoverInput) {
          turnoverInput.addEventListener("input", function () {
            const cursorPos = this.selectionStart;
            const oldValue = this.value;
            let newValue = this.value.replace(/[^0-9.]/g, "");
            const parts = newValue.split(".");
            if (parts[0] && parts[0].length > 6) {
              parts[0] = parts[0].slice(0, 6);
              newValue = parts.join(".");
            }
            if (oldValue !== newValue) {
              this.value = newValue;
              this.setSelectionRange(cursorPos, cursorPos);
            }
          });
        }

        const capitalInput = document.getElementById("swal-capital");
        if (capitalInput) {
          capitalInput.addEventListener("input", function () {
            const cursorPos = this.selectionStart;
            const oldValue = this.value;
            let newValue = this.value.replace(/[^0-9.]/g, "");
            const parts = newValue.split(".");
            if (parts[0] && parts[0].length > 6) {
              parts[0] = parts[0].slice(0, 6);
              newValue = parts.join(".");
            }
            if (oldValue !== newValue) {
              this.value = newValue;
              this.setSelectionRange(cursorPos, cursorPos);
            }
          });
        }
      },
      preConfirm: () => {
        const year = (document.getElementById("swal-year").value || "").trim();
        const turnover = document.getElementById("swal-turnover").value;

        if (!turnover) {
          Swal.showValidationMessage("Please enter turnover");
          return false;
        }

        const turnoverParts = String(turnover).split(".");
        if (turnoverParts[0] && turnoverParts[0].length > 6) {
          Swal.showValidationMessage("Turnover cannot exceed 6 digits");
          return false;
        }

        const formValues = {
          financial_year: year,
          fy_turnover: turnover,
          dir_employ_male: row.dir_employ_male || "",
          dir_employ_female: row.dir_employ_female || "",
          dir_employ_others: row.dir_employ_others || "",
          dir_employ_sc_st: row.dir_employ_sc_st || "",
          dir_employ_pwd: row.dir_employ_pwd || "",
        };

        const remarkValue = (
          document.getElementById("swal-remark")?.value || ""
        ).trim();
        formValues.remarks = remarkValue || null;

        if (data?.company_status === "existing_company") {
          const capitalInvestment =
            document.getElementById("swal-capital")?.value || "";
          if (capitalInvestment) {
            const capitalParts = String(capitalInvestment).split(".");
            if (capitalParts[0] && capitalParts[0].length > 6) {
              Swal.showValidationMessage(
                "Capital investment cannot exceed 6 digits"
              );
              return false;
            }
          }
          formValues.capital_investment = capitalInvestment || "0";
        }

        return formValues;
      },
    });

    if (formValues) {
      try {
        await update_financial_record(data.id, row.financial_year, formValues);
        loadData(true);
        Swal.fire({ icon: "success", title: "Updated" });
      } catch (e) {
        const errorMsg =
          e?.response?.data?.message || e?.message || "Failed to update";
        Swal.fire({ icon: "error", title: "Failed to update", text: errorMsg });
      }
    }
  };

  const handleEditEmploymentRecord = async (row) => {
    if (!data?.id) return;
    const { value: formValues } = await Swal.fire({
      title: '<span style="font-size: 18px;">Edit Employment Record</span>',
      width: "700px",
      html:
        '<div class="form-group mb-2">' +
        '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">Financial Year</label>' +
        `<input id="swal-year" class="form-control" value="${row.financial_year || ""}" disabled style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da; background-color: #f8f9fa;margin-bottom: 20px;">` +
        "</div>" +
        '<div class="form-group mb-2">' +
        '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">Male <span style="color: red;">*</span></label>' +
        `<input id="swal-male" type="number" class="form-control" placeholder="Enter male count" value="${row.dir_employ_male || ""}" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').slice(0, 6);" style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">` +
        "</div>" +
        '<div class="form-group mb-2">' +
        '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">Female <span style="color: red;">*</span></label>' +
        `<input id="swal-female" type="number" class="form-control" placeholder="Enter female count" value="${row.dir_employ_female || ""}" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').slice(0, 6);" style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">` +
        "</div>" +
        '<div class="form-group mb-2">' +
        '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">Genderqueer <span style="color: red;">*</span></label>' +
        `<input id="swal-genderqueer" type="number" class="form-control" placeholder="Enter genderqueer count" value="${row.dir_employ_others || ""}" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').slice(0, 6);" style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">` +
        "</div>" +
        '<div class="form-group mb-2">' +
        '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">SC/ST <span style="color: red;">*</span></label>' +
        `<input id="swal-scst" type="number" class="form-control" placeholder="Enter SC/ST count" value="${row.dir_employ_sc_st || ""}" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').slice(0, 6);" style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">` +
        "</div>" +
        '<div class="form-group mb-3">' +
        '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">PWD <span style="color: red;">*</span></label>' +
        `<input id="swal-pwd" type="number" class="form-control" placeholder="Enter PWD count" value="${row.dir_employ_pwd || ""}" oninput="this.value = this.value.replace(/[^0-9]/g, \'\').slice(0, 6);" style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da;margin-bottom: 20px;">` +
        "</div>",
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Update",
      confirmButtonColor: "#0A223D",
      cancelButtonColor: "#6c757d",
      didOpen: () => {
        const confirmBtn = document.querySelector(".swal2-confirm");
        const cancelBtn = document.querySelector(".swal2-cancel");
        if (confirmBtn) confirmBtn.style.minWidth = "120px";
        if (cancelBtn) cancelBtn.style.minWidth = "120px";
      },
      preConfirm: () => {
        const male = document.getElementById("swal-male").value;
        const female = document.getElementById("swal-female").value;
        const genderqueer = document.getElementById("swal-genderqueer").value;
        const sc_st = document.getElementById("swal-scst").value;
        const pwd = document.getElementById("swal-pwd").value;

        if (!male || !female || !genderqueer || !sc_st || !pwd) {
          Swal.showValidationMessage(
            "Please fill all employment fields (Male, Female, Genderqueer, SC/ST, PWD)"
          );
          return false;
        }

        return {
          financial_year: row.financial_year,
          fy_turnover: row.fy_turnover || "",
          capital_investment: row.capital_investment || "",
          remark: row.remarks || "",
          dir_employ_male: male,
          dir_employ_female: female,
          dir_employ_others: genderqueer,
          dir_employ_sc_st: sc_st,
          dir_employ_pwd: pwd,
        };
      },
    });

    if (formValues) {
      try {
        await update_financial_record(data.id, row.financial_year, formValues);
        loadData(true);
        Swal.fire({ icon: "success", title: "Updated" });
      } catch (e) {
        const errorMsg =
          e?.response?.data?.message || e?.message || "Failed to update";
        Swal.fire({ icon: "error", title: "Failed to update", text: errorMsg });
      }
    }
  };

  // Student specific helpers
  const getQualificationTypeName = (typeId) => {
    const type = (data?.qualificationsData || []).find(
      (q) => q.id?.toString() === typeId?.toString()
    );
    return type?.name || typeId;
  };

  const getQualificationName = (typeId, qualId) => {
    const type = (data?.qualificationsData || []).find(
      (q) => q.id?.toString() === typeId?.toString()
    );
    const qual = (type?.children_recursive || []).find(
      (q) => q.id?.toString() === qualId?.toString()
    );
    return qual?.name || qualId;
  };

  const getStreamName = (typeId, qualId, streamId) => {
    const type = (data?.qualificationsData || []).find(
      (q) => q.id?.toString() === typeId?.toString()
    );
    const qual = (type?.children_recursive || []).find(
      (q) => q.id?.toString() === qualId?.toString()
    );
    const stream = (qual?.children_recursive || []).find(
      (q) => q.id?.toString() === streamId?.toString()
    );
    return stream?.name || streamId;
  };

  const isUpdateVisible = () => {
    const roleNum = Number(userRole);

    // Check if affiliated company (role 5, company_type === "kerala", or token context_type === "company")
    const isAffiliated = roleNum === 5 ||
      data?.company_type === "kerala" ||
      data?.parent_company?.company_type === "kerala" ||
      props?.companyData?.parent_company?.company_type === "kerala" ||
      props?.userDetails?.context_type === "company" ||
      props?.userDetails?.user?.context_type === "company";

    if (isAffiliated) {
      return true; // Always visible for affiliated companies
    }

    // Check if other company user (0, 4, 6) or matches company user flag
    const isCompany = [0, 4, 6].includes(roleNum) || data?.is_company_user;
    if (isCompany) {
      return false; // Non-affiliated companies cannot update
    }

    // For non-company users, strictly enforce Reverted or Rejected status
    if ([8, 9, 10, 27].includes(roleNum)) {
      const status = Number(data?.approval_status ?? data?.application_status);
      return status === 4 || status === 5;
    }
    if (roleNum === 20) {
      const status = Number(data?.status);
      // For candidate, reverted is 3, rejected is 5
      return status === 3 || status === 5;
    }
    if (roleNum === 24) {
      const status = Number(data?.status);
      // For vendor, reverted to admin is 6, reverted to user is 7, payment issue is 8
      return status === 6 || status === 7 || status === 8;
    }

    return false;
  };

  const handleEditProfile = () => {
    const roleNum = Number(userRole);
    let path = "/";
    switch (roleNum) {
      case 0:
        path = "/update-company";
        break;
      case 4:
        path = "/update-kspace";
        break;
      case 5:
        path = "/update-kerala";
        break;
      case 6:
        path = "/update-india";
        break;
      case 8:
        path = "/update-academy";
        break;
      case 9:
        path = "/update-resource";
        break;
      case 10:
        path = "/update-manpower";
        break;
      case 20:
        path = "/update-candidate";
        break;
      case 24:
        path = "/vendor-registration";
        break;
      case 27:
        path = "/training-reg";
        break;
      default:
        path = "/";
    }
    history.push(path);
  };

  // ── Sub-renderers ───────────────────────────────────────────────────────────

  const renderAreaRequirements = () => {
    const spaceRent = data?.area_management?.filter(
      (item) => item.area_type === "built_up_space"
    ) || [];
    const facilityRent = data?.area_management?.filter(
      (item) => item.area_type === "equipped_facility"
    ) || [];
    const landLease = data?.area_management?.filter(
      (item) => item.area_type === "land_lease"
    ) || [];
    const jointVenture = data?.area_management?.filter(
      (item) => item.area_type === "joint_venture"
    ) || [];
    const ownPremises = data?.area_management?.filter(
      (item) => item.area_type === "own_land"
    ) || [];

    return (
      <div className="mt-4 px-3">
        {spaceRent.length > 0 && (
          <div className="mb-4">
            <h5 className="area-title mb-3 font-weight-bold text-primary d-flex align-items-center gap-2" style={{ fontSize: "16px" }}>
              <i className="fa fa-building" style={{ color: "#0a223d" }}></i>
              Built-up space on Rent per Month
            </h5>
            <div className="overflow-auto w-100">
              <CustomTable
                className="areatable"
                {...props}
                columns={[
                  { title: "Preference No", field: "id", type: "dynId" },
                  { title: "Location", field: "location" },
                  { title: "Sub Location", field: "sub_location" },
                  {
                    title: "Category",
                    field: "area_type",
                    render: (rowData) =>
                      rowData.area_type === "built_up_space"
                        ? "Built-up Space"
                        : "Land",
                  },
                  {
                    title: "Built-Up Space Category",
                    field: "built_space_type",
                  },
                  {
                    title: "Area Requirement (Requested area in sqft)",
                    field: "area_in_sqft",
                  },

                ]}
                data={spaceRent}
              />
            </div>
          </div>
        )}

        {facilityRent.length > 0 && (
          <div className="mb-4">
            <h5 className="area-title mb-3 font-weight-bold text-primary d-flex align-items-center gap-2" style={{ fontSize: "16px" }}>
              <i className="fa fa-desktop" style={{ color: "#0a223d" }}></i>
              Equipped Facility per Month
            </h5>
            <div className="overflow-auto w-100">
              <CustomTable
                className="areatable"
                {...props}
                columns={[
                  { title: "Location", field: "location" },
                  { title: "Block No", field: "block_no" },
                  { title: "Number of Seats", field: "no_of_seats" },
                ]}
                data={facilityRent}
              />
            </div>
          </div>
        )}

        {landLease.length > 0 && (
          <div className="mb-4">
            <h5 className="area-title mb-3 font-weight-bold text-primary d-flex align-items-center gap-2" style={{ fontSize: "16px" }}>
              <i className="fa fa-map-marker" style={{ color: "#0a223d" }}></i>
              Land on Lease
            </h5>
            <div className="overflow-auto w-100">

              <CustomTable
                className="areatable"
                {...props}
                columns={[
                  { title: "Preference No", field: "id", type: "dynId" },
                  { title: "Location", field: "location" },
                  { title: "Sub Location", field: "sub_location" },
                  {
                    title: "Category",
                    field: "area_type",
                    render: (rowData) =>
                      rowData.area_type === "built_up_space"
                        ? "Built-up Space"
                        : "Land On Lease",
                  },
                  {
                    title: "Land Requirement(in cents)",
                    field: "area_in_acres",
                  },
                  { title: "Lease Years", field: "lease_year" },
                ]}
                data={landLease}
              />
            </div>
          </div>
        )}

        {jointVenture.length > 0 && (
          <div className="mb-4">
            <h5 className="area-title mb-3 font-weight-bold text-primary d-flex align-items-center gap-2" style={{ fontSize: "16px" }}>
              <i className="fa fa-handshake-o" style={{ color: "#0a223d" }}></i>
              Joint Venture Requirements
            </h5>
            <div className="overflow-auto w-100">
              <CustomTable
                className="areatable"
                {...props}
                columns={[
                  { title: "Location", field: "location" },
                  {
                    title: "Category",
                    field: "joint_venture_category",
                    render: (rowData) =>
                      rowData.joint_venture_category === "built-up"
                        ? "Built-up Space"
                        : rowData.joint_venture_category === "land"
                          ? "Land"
                          : "--",
                  },
                  {
                    title: "Area Type",
                    field: "built_space_type",
                    render: (rowData) => rowData.built_space_type || "--",
                  },
                  {
                    title: "Area / Land Requirement",
                    field: "area_in_sqft",
                    render: (rowData) =>
                      rowData.area_in_sqft
                        ? `${rowData.area_in_sqft} ${rowData.joint_venture_category === "land"
                          ? "Cents"
                          : "Sq.ft"
                        }`
                        : "--",
                  },
                  {
                    title: "Lease Years",
                    field: "lease_year",
                    render: (rowData) => rowData.lease_year || "--",
                  },
                  { title: "Investment Model", field: "investment_model" },
                  { title: "Management Plan", field: "management_plan" },
                  { title: "Address", field: "land_address" },
                ]}
                data={jointVenture}
              />
            </div>
          </div>
        )}

        {ownPremises.length > 0 && (
          <div className="mb-4">
            <h5 className="area-title mb-3 font-weight-bold text-primary d-flex align-items-center gap-2" style={{ fontSize: "16px" }}>
              <i className="fa fa-home" style={{ color: "#0a223d" }}></i>
              Own Premises Details
            </h5>
            <div className="overflow-auto w-100">
              <CustomTable
                className="areatable"
                {...props}
                columns={[
                  { title: "Location", field: "location" },
                  { title: "Sub Location", field: "sub_location" },
                  { title: "Available Area", field: "area_in_sqft" },
                  { title: "Land Address", field: "land_address" },
                  { title: "Survey Number", field: "survey_no" },
                  { title: "Block Number", field: "block_no" },
                  { title: "Village Name", field: "village_name" },
                  { title: "Management Plan", field: "management_plan" },
                  { title: "Nature Of Holding", field: "nature_of_holding" },
                  {
                    title: "Interest in JV",
                    render: (rowData) =>
                      hasValue(rowData?.proposal_file) ? "Yes" : "No",
                  },
                  ...(data?.area_management?.some((item) => hasValue(item?.proposal_file))
                    ? [
                      {
                        title: "Proposal File",
                        render: (rowData) =>
                          hasValue(rowData?.proposal_file) ? (
                            <button
                              onClick={() => fullfileDownload(rowData.proposal_file)}
                              className="btn btn-approve btn-success btn-sm"
                            >
                              View File
                            </button>
                          ) : null,
                      },
                    ]
                    : []),
                ]}
                data={ownPremises}
              />
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderFinancialAndEmployment = () => {
    const roleNum = Number(userRole);
    const now = new Date();
    const currYear = now.getFullYear();
    const startYear = 2024;
    const existingYears = data?.financial_records?.map((record) => record.financial_year) || [];
    let hasAvailableYears = false;
    for (let i = startYear; i <= currYear; i++) {
      const fyOption = `${i}-${i + 1}`;
      if (!existingYears.includes(fyOption)) {
        hasAvailableYears = true;
        break;
      }
    }

    return (
      <>
        {data?.financial_records && (
          <div className="mt-4 px-3">
            <div className="d-flex justify-content-between align-items-center gap-2 mb-2">
              <h6 className="mb-0"><b>Financial Records</b></h6>
              {jwtDecode(props.state.payload)?.context_type === "application" && hasAvailableYears && (
                <button
                  className="btn btn-approve btn-success btn-sm"
                  onClick={handleAddFinancialRecord}
                  disabled={props?.companyData?.is_company_user}
                >
                  {data?.company_status === "existing_company" && data?.company_type === "kerala"
                    ? "Add Records"
                    : "Add Financial Record"}
                </button>
              )}
            </div>
            <hr />
            <div className="overflow-auto w-100 mb-4">
              <CustomTable
                className="areatable"
                {...props}
                columns={[
                  { title: "Financial Year", field: "financial_year" },
                  { title: "Turnover (Cr)", field: "fy_turnover" },
                  ...(data?.company_status === "existing_company" && data?.company_type === "kerala"
                    ? [
                      { title: "Capital (Cr)", field: "capital_investment" },
                      { title: "Remarks", field: "remarks" }
                    ]
                    : []),
                  // {
                  //   title: "Actions",
                  //   field: "actions",
                  //   render: (row) => (
                  //     <button
                  //       className="btn btn-sm btn-primary"
                  //       onClick={() => handleEditFinancialRecord(row)}
                  //       disabled={props?.companyData?.is_company_user}
                  //     >
                  //       Edit
                  //     </button>
                  //   ),
                  // },
                ]}
                data={data.financial_records}
              />
            </div>

            {(roleNum === 4 || roleNum === 5) &&
              data?.company_status === "existing_company" &&
              jwtDecode(props.state.payload)?.context_type !== "application" && (
                <div>
                  <h6 className="mb-2"><b>Employment Details</b></h6>
                  <hr />
                  <div className="overflow-auto w-100">
                    <CustomTable
                      className="areatable"
                      {...props}
                      columns={[
                        { title: "Financial Year", field: "financial_year" },
                        { title: "Male", field: "dir_employ_male" },
                        { title: "Female", field: "dir_employ_female" },
                        { title: "Genderqueer", field: "dir_employ_others" },
                        { title: "SC/ST", field: "dir_employ_sc_st" },
                        { title: "PWD", field: "dir_employ_pwd" },
                        { title: "Total Direct Employment", field: "direct_emp" },
                        // {
                        //   title: "Actions",
                        //   field: "actions",
                        //   render: (row) => (
                        //     <button
                        //       className="btn btn-sm btn-primary"
                        //       onClick={() => handleEditEmploymentRecord(row)}
                        //       disabled={props?.companyData?.is_company_user}
                        //     >
                        //       Edit
                        //     </button>
                        //   ),
                        // },
                      ]}
                      data={data.financial_records}
                    />
                  </div>
                </div>
              )}
          </div>
        )}
      </>
    );
  };

  const renderCompanyDetails = () => {
    return (
      <div className="dash-items-data">
        {(data?.company_name || data?.parent_company?.name) && (
          <div className="row">
            <div className="col-3">Company Name</div>
            <div className="col-1">:</div>
            <div className="col-8">
              {(() => {
                const name = data?.company_name || data?.parent_company?.name;
                if (!name || typeof name !== "string") return name;
                return name.charAt(0).toUpperCase() + name.slice(1);
              })()}
            </div>
          </div>
        )}

        {(data?.unique_application_ref_no || data?.company?.unique_application_ref_no) && (
          <div className="row">
            <div className="col-3">Application ID</div>
            <div className="col-1">:</div>
            <div className="col-8">
              {data?.company?.unique_application_ref_no || data?.unique_application_ref_no}
            </div>
          </div>
        )}

        {data?.application_status !== undefined && (
          <div className="row">
            <div className="col-3">Application Status</div>
            <div className="col-1">:</div>
            <div className="col-8">
              {(() => {
                const status = data?.application_status;
                if (status === 0) return "Pending";
                if (status === 1) return "Submitted";
                if (status === 2) return "Approved";
                if (status === 3) return "In Progress";
                if (status === 5) return "Reverted";
                if (status === 4) return "Rejected";
                if (status === 6) return "Agreement Execution";
                if (status === 7) return "Ongoing Project";
                if (status === 8) return "Completed";
                if (status === 16) return "Waiting for final approval";
                if (status === 15) return "Suggestion";
                return "";
              })()}
            </div>
          </div>
        )}
        {data?.project_status !== undefined && (
          <div className="row">
            <div className="col-3">Application Status</div>
            <div className="col-1">:</div>
            <div className="col-8">
              {(() => {
                const s = data?.project_status;
                if (s !== undefined && s !== null) {
                  return s === 0
                    ? "Pending"
                    : s === 1
                      ? "Submitted for Acceptance"
                      : s === 2
                        ? "Approved"
                        : s === 3
                          ? "Super Admin Reverted"
                          : s === 4
                            ? "Rejected"
                            : s === 5
                              ? "Reverted"
                              : "";
                }
                return "";
              })()}
            </div>
          </div>
        )}

        {data?.person_name && (
          <div className="row">
            <div className="col-3">Contact Person</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.person_name}</div>
          </div>
        )}

        {data?.person_designation && (
          <div className="row">
            <div className="col-3">Person Designation</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.person_designation}</div>
          </div>
        )}

        {data?.address && (
          <div className="row">
            <div className="col-3">Company Address</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.address}</div>
          </div>
        )}

        {data?.phone_no && (
          <div className="row">
            <div className="col-3">Company Phone</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.phone_no}</div>
          </div>
        )}

        {data?.email && (
          <div className="row">
            <div className="col-3">Company Email</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.email}</div>
          </div>
        )}

        {data?.alternate_phone && (
          <div className="row">
            <div className="col-3">Alternate Phone</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.alternate_phone}</div>
          </div>
        )}

        {data?.alternate_email && (
          <div className="row">
            <div className="col-3">Alternate Email</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.alternate_email}</div>
          </div>
        )}

        {hasValue(data?.capital_investment) && (
          <div className="row">
            <div className="col-3">Capital Investment</div>
            <div className="col-1">:</div>
            <div className="col-8">{data.capital_investment}</div>
          </div>
        )}

        {/* {hasValue(data?.ex_man_power) && (
          <div className="row">
            <div className="col-3">Existing Manpower</div>
            <div className="col-1">:</div>
            <div className="col-8">{data.ex_man_power}</div>
          </div>
        )} */}

        {hasValue(data?.fe_component) && (
          <div className="row">
            <div className="col-3">Foreign Exchange (FE)</div>
            <div className="col-1">:</div>
            <div className="col-8">{data.fe_component}</div>
          </div>
        )}

        {data?.area_type && (
          <div className="row">
            <div className="col-3">Area Type</div>
            <div className="col-1">:</div>
            <div className="col-8">
              {data?.area_type?.replace(/_/g, " ").toUpperCase()}
            </div>
          </div>
        )}

        {data?.financial_year && (
          <div className="row">
            <div className="col-3">Financial Year</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.financial_year}</div>
          </div>
        )}

        {data?.fy_turnover && (
          <div className="row">
            <div className="col-3">FY Turnover</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.fy_turnover || "Not Provided"}</div>
          </div>
        )}

        {data?.cin_number && (
          <div className="row">
            <div className="col-3">CIN Number</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.cin_number}</div>
          </div>
        )}

        {data?.site_link && (
          <div className="row">
            <div className="col-3">Website</div>
            <div className="col-1">:</div>
            <div className="col-8">
              <a href={data?.site_link} target="_blank" rel="noopener noreferrer" className="text-primary">
                Visit Website
              </a>
            </div>
          </div>
        )}

        {data?.abstract_project_proposal && (
          <div className="row">
            <div className="col-3">Project Proposal</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.abstract_project_proposal}</div>
          </div>
        )}

        {data?.upload_proposal && (
          <div className="row">
            <div className="col-3">Proposal Document</div>
            <div className="col-1">:</div>
            <div className="col-8">
              <button
                className="btn btn-approve btn-success btn-sm"
                onClick={() => fullfileDownload(data?.upload_proposal)}
              >
                View Proposal
              </button>
            </div>
          </div>
        )}

        {/* {data?.logo && ( */}
        <div className="row mb-3 align-items-center">
          <div className="col-3">Company Logo</div>
          <div className="col-1">:</div>
          <div className="col-8">
            <div className="d-flex align-items-center flex-wrap gap-2">
              {data?.logo && (
                <button
                  className="btn btn-approve btn-success ovr btn-sm"
                  onClick={() => fullfileDownload(data?.logo)}
                >
                  View Logo
                </button>
              )}
              {jwtDecode(props.state.payload)?.context_type === "application" && !props.companyData?.is_company_user && (
                <button
                  className="btn btn-approve btn-success ovr btn-sm"
                  onClick={handleUploadLogo}
                >
                  Update Logo
                </button>
              )}
            </div>
          </div>
        </div>
        {/* )} */}

        {data?.domain_types && data?.domain_types?.length > 0 && (
          <div className="row">
            <div className="col-3">Domain Types</div>
            <div className="col-1">:</div>
            <div className="col-8">
              {data?.domain_types?.map((domain) => (
                <div key={domain.id} className="mb-1">• {domain.domain_name}</div>
              ))}
            </div>
          </div>
        )}

        {data?.product_profiles && data?.product_profiles?.length > 0 && (
          <div className="row">
            <div className="col-3">Products</div>
            <div className="col-1">:</div>
            <div className="col-8">
              {data?.product_profiles?.map((product) => (
                <div key={product.id} className="mb-2">
                  <strong>{product.product_name}</strong>
                  <div style={{ fontSize: "12px", color: "#666" }}>
                    {ReactHtmlParser(product.product_desc)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {renderAreaRequirements()}
        {renderFinancialAndEmployment()}
      </div>
    );
  };

  const renderAcademicDetails = () => {
    return (
      <div className="dash-items-data">
        {data?.institution_name && (
          <div className="row">
            <div className="col-3">Institution Name</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.institution_name}</div>
          </div>
        )}

        {data?.address && (
          <div className="row">
            <div className="col-3">Registered Office Address</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.address}</div>
          </div>
        )}

        {data?.headquaters_detail && (
          <div className="row">
            <div className="col-3">HQ Details</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.headquaters_detail}</div>
          </div>
        )}

        {data?.phone_no && (
          <div className="row">
            <div className="col-3">Contact Number</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.phone_no}</div>
          </div>
        )}

        {data?.alternate_phone && (
          <div className="row">
            <div className="col-3">Alternate Contact Number</div>
            <div className="col-1">:</div>
            <div className="col-8">
              {data?.country_code && `${data?.country_code}-`}
              {data?.alternate_phone}
            </div>
          </div>
        )}

        {data?.email && (
          <div className="row">
            <div className="col-3">Email ID</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.email}</div>
          </div>
        )}

        {data?.alternate_email && (
          <div className="row">
            <div className="col-3">Alternate Email ID</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.alternate_email}</div>
          </div>
        )}

        {data?.authorized_person_name && (
          <div className="row">
            <div className="col-3">Authorized Person Name</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.authorized_person_name}</div>
          </div>
        )}

        {data?.authorized_person_designation && (
          <div className="row">
            <div className="col-3">Authorized Person Designation</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.authorized_person_designation}</div>
          </div>
        )}

        {data?.financial_year && (
          <div className="row">
            <div className="col-3">Financial Year</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.financial_year}</div>
          </div>
        )}

        {data?.affiliation && (
          <div className="row">
            <div className="col-3">Affiliation Details</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.affiliation}</div>
          </div>
        )}

        {data?.total_students && (
          <div className="row">
            <div className="col-3">Total Number of Students</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.total_students}</div>
          </div>
        )}

        {data?.course_details && (
          <div className="row">
            <div className="col-3">Courses Offered</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.course_details}</div>
          </div>
        )}

        {data?.notes_institutions && (
          <div className="row">
            <div className="col-3">Brief Note on Institution Activities</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.notes_institutions}</div>
          </div>
        )}

        {data?.file_registration_proof && (
          <div className="row">
            <div className="col-3">Proof of Registration</div>
            <div className="col-1">:</div>
            <div className="col-8">
              <button
                className="btn btn-approve btn-success btn-sm"
                onClick={() => fullfileDownload(data?.file_registration_proof)}
              >
                View Document
              </button>
            </div>
          </div>
        )}

        {data?.file_submitted_record && (
          <div className="row">
            <div className="col-3">Request Letter on Letterhead</div>
            <div className="col-1">:</div>
            <div className="col-8">
              <button
                className="btn btn-approve btn-success btn-sm"
                onClick={() => fullfileDownload(data?.file_submitted_record)}
              >
                View Document
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderResourceDetails = () => {
    return (
      <div className="dash-items-data">
        <div className="row">
          <div className="col-3">Full Name</div>
          <div className="col-1">:</div>
          <div className="col-8">
            {data?.title ? data?.title + "." : "Mr."} {data?.first_name ?? ""}{" "}
            {data?.last_name ?? ""}
          </div>
        </div>

        {data?.date_of_birth && (
          <div className="row">
            <div className="col-3">Date of Birth</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.date_of_birth}</div>
          </div>
        )}

        {data?.gender && (
          <div className="row">
            <div className="col-3">Gender</div>
            <div className="col-1">:</div>
            <div className="col-8">
              {data?.gender === 1
                ? "Male"
                : data?.gender === 2
                  ? "Female"
                  : data?.gender === 3
                    ? "Other"
                    : ""}
            </div>
          </div>
        )}

        {data?.address && (
          <div className="row">
            <div className="col-3">Address</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.address}</div>
          </div>
        )}

        {data?.email && (
          <div className="row">
            <div className="col-3">Email</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.email}</div>
          </div>
        )}

        {data?.mobile && (
          <div className="row">
            <div className="col-3">Phone Number</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.mobile}</div>
          </div>
        )}

        {data?.alternate_phone && (
          <div className="row">
            <div className="col-3">Alternate Phone</div>
            <div className="col-1">:</div>
            <div className="col-8">
              {data?.country_code && `${data?.country_code}-`}
              {data?.alternate_phone}
            </div>
          </div>
        )}

        {data?.languages && data?.languages?.length > 0 && (
          <div className="row">
            <div className="col-3">Languages Known</div>
            <div className="col-1">:</div>
            <div className="col-8">
              {data?.languages?.map((dom, i) => (
                <React.Fragment key={i}>
                  {i !== 0 && " | "}
                  {dom.language_name || dom.language}
                </React.Fragment>
              ))}
            </div>
          </div>
        )}

        {data?.domain_types && data?.domain_types?.length > 0 && (
          <div className="row">
            <div className="col-3">Domain Type</div>
            <div className="col-1">:</div>
            <div className="col-8">
              {data?.domain_types?.map((dom, i) => (
                <div key={i}>{dom.domain_name}</div>
              ))}
            </div>
          </div>
        )}

        {data?.area_of_expertise && data?.area_of_expertise?.length > 0 && (
          <div className="row">
            <div className="col-3">Area of Expertise</div>
            <div className="col-1">:</div>
            <div className="col-8">
              {data?.area_of_expertise?.map((dom, i) => (
                <React.Fragment key={i}>
                  {i !== 0 && " | "}
                  {dom.expertise_name}
                </React.Fragment>
              ))}
            </div>
          </div>
        )}

        <div className="row">
          <div className="col-3">Willingness to travel within India/abroad</div>
          <div className="col-1">:</div>
          <div className="col-8">
            {data?.is_willing_to_travel === 1 ? "Yes" : "No"}
          </div>
        </div>

        {data?.organization_details && (
          <div className="row">
            <div className="col-3">Currently attached to any Organization?</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.organization_details}</div>
          </div>
        )}

        {data?.photo && (
          <div className="row">
            <div className="col-3">Uploaded Photo</div>
            <div className="col-1">:</div>
            <div className="col-8">
              <img
                src={getFileUrl(data?.photo)}
                alt="Profile"
                style={{ maxWidth: "150px", border: "1px solid #ccc", padding: "4px" }}
              />
            </div>
          </div>
        )}

        {data?.resume_name && (
          <div className="row">
            <div className="col-3">Uploaded Resume</div>
            <div className="col-1">:</div>
            <div className="col-8">
              <button
                className="btn btn-approve btn-success btn-sm"
                onClick={() => fullfileDownload(data?.resume || data?.resume_name)}
              >
                Download Resume
              </button>
            </div>
          </div>
        )}

        {/* Educational Qualifications */}
        {(data?.education || data?.educational_qualifications) && (
          <div className="mt-4">
            <h6 className="font-weight-bold mb-2">Educational Qualifications</h6>
            <hr />
            <div className="overflow-auto w-100">
              <CustomTable
                className="areatable"
                {...props}
                columns={[
                  { title: "Examination Passed", field: "examination_passed" },
                  { title: "Board / University", field: "board_of_university" },
                  { title: "Year of Pass", field: "year_of_pass" },
                  { title: "Marks / Grade", field: "mark_grade" },
                  {
                    title: "Certificate",
                    field: "edu_certificate",
                    type: "download",
                  },
                ]}
                data={data?.education || data?.educational_qualifications || []}
              />
            </div>
          </div>
        )}

        {/* Experience Details */}
        {(data?.employment || data?.work_experience) && (
          <div className="mt-4">
            <h6 className="font-weight-bold mb-2">Experience Details</h6>
            <hr />
            <div className="overflow-auto w-100">
              <CustomTable
                className="areatable"
                {...props}
                columns={[
                  { title: "Organization", field: "organization_name" },
                  { title: "Designation", field: "designation" },
                  { title: "Experience (Yrs)", field: "experience" },
                  { title: "Nature of Work", field: "nature_of_work" },
                  { title: "Reason for Leaving", field: "reason_for_leaving" },
                  {
                    title: "Certificate",
                    field: "experience_certificate",
                    type: "download",
                  },
                ]}
                data={data?.employment || data?.work_experience || []}
              />
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderExpertDetails = () => {
    return (
      <div className="dash-items-data">
        {data?.category && (
          <div className="row">
            <div className="col-3 font-weight-bold">Manpower Type</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.category}</div>
          </div>
        )}

        <div className="row">
          <div className="col-3 font-weight-bold">Name</div>
          <div className="col-1">:</div>
          <div className="col-8">
            {data?.title ? data?.title + "." : "Mr."} {data?.first_name ?? ""}{" "}
            {data?.last_name ?? ""}
          </div>
        </div>

        {data?.date_of_birth && (
          <div className="row">
            <div className="col-3 font-weight-bold">Date of Birth</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.date_of_birth}</div>
          </div>
        )}

        {data?.gender !== undefined && data?.gender !== null && (
          <div className="row">
            <div className="col-3 font-weight-bold">Gender</div>
            <div className="col-1">:</div>
            <div className="col-8">
              {Number(data?.gender) === 1
                ? "Male"
                : Number(data?.gender) === 2
                  ? "Female"
                  : Number(data?.gender) === 3
                    ? "Other"
                    : (typeof data?.gender === "string" ? data?.gender : "")}
            </div>
          </div>
        )}

        {data?.address && (
          <div className="row">
            <div className="col-3 font-weight-bold">Address</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.address}</div>
          </div>
        )}

        {data?.email && (
          <div className="row">
            <div className="col-3 font-weight-bold">Email</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.email}</div>
          </div>
        )}

        {data?.phone_no && (
          <div className="row">
            <div className="col-3 font-weight-bold">Phone Number</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.phone_no}</div>
          </div>
        )}

        {data?.alternate_phone && (
          <div className="row">
            <div className="col-3 font-weight-bold">Alternate Phone</div>
            <div className="col-1">:</div>
            <div className="col-8">
              {data?.country_code &&
                data?.country_code !== "" &&
                data?.country_code !== "null" &&
                data?.country_code !== "undefined" && (
                  <>
                    {data?.country_code ?? ""}{" "}
                    {data?.country_code && data?.country_code !== ""
                      ? "-"
                      : ""}{" "}
                  </>
                )}
              {data?.alternate_phone ?? ""}
            </div>
          </div>
        )}

        {data?.area_of_expertise && data?.area_of_expertise?.length > 0 && (
          <div className="row">
            <div className="col-3 font-weight-bold">Area of Expertise</div>
            <div className="col-1">:</div>
            <div className="col-8">
              {data?.area_of_expertise?.map((dom, i) => (
                <div key={i}>{dom.expertise_name}</div>
              ))}
            </div>
          </div>
        )}

        {data?.photo && (
          <div className="row">
            <div className="col-3 font-weight-bold">Photo</div>
            <div className="col-1">:</div>
            <div className="col-8">
              <img
                src={getFileUrl(data?.photo)}
                alt="Profile"
                style={{ maxWidth: "150px", border: "1px solid #ccc", padding: "4px" }}
              />
            </div>
          </div>
        )}

        {data?.resume && (
          <div className="row">
            <div className="col-3 font-weight-bold">Resume</div>
            <div className="col-1">:</div>
            <div className="col-8">
              <button
                className="btn btn-approve btn-success btn-sm"
                onClick={() => fileDownload(data?.resume)}
              >
                Download Resume
              </button>
            </div>
          </div>
        )}

        {/* Educational Qualifications */}
        {data?.education && data?.education?.length > 0 && (
          <div className="mt-4">
            <h6 className="font-weight-bold mb-2">Educational Qualification</h6>
            <hr />
            <div className="overflow-auto w-100">
              <CustomTable
                className="areatable"
                {...props}
                handleDownload={handleTableDownload}
                columns={[
                  { title: "Examination passed", field: "examination_passed" },
                  { title: "Board/University", field: "board_of_university" },
                  { title: "Year of Passing", field: "year_of_pass" },
                  { title: "Mark/grade", field: "mark_grade" },
                  {
                    title: "Certificate",
                    field: "file_upload_certificate",
                    type: "download",
                  },
                ]}
                data={data?.education}
              />
            </div>
          </div>
        )}

        {/* Experience Details */}
        {data?.experience && data?.experience?.length > 0 && (
          <div className="mt-4">
            <h6 className="font-weight-bold mb-2">Experience Details</h6>
            <hr />
            <div className="overflow-auto w-100">
              <CustomTable
                className="areatable"
                {...props}
                handleDownload={handleTableDownload}
                columns={[
                  { title: "Organization with Address", field: "organization_name" },
                  {
                    title: "Experience",
                    field: "experience",
                    render: (row) => row.experience ? `${row.experience} Years` : ""
                  },
                  { title: "Nature of Work", field: "nature_of_work" },
                  { title: "Designation", field: "designation" },
                  { title: "Reason for Leaving", field: "reason_for_leaving" },
                  {
                    title: "Certificate",
                    field: "experience_certificate",
                    type: "download",
                  },
                ]}
                data={data?.experience}
              />
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderCandidateDetails = () => {
    return (
      <div className="dash-items-data">
        <div className="row">
          <div className="col-3">Are you a Native Keralite?</div>
          <div className="col-1">:</div>
          <div className="col-8">{data?.native_kerala === 1 ? "Yes" : "No"}</div>
        </div>

        {data?.native_kerala === 0 && (
          <div className="row">
            <div className="col-3">Non-Resident Keralite?</div>
            <div className="col-1">:</div>
            <div className="col-8">Yes</div>
          </div>
        )}

        {data?.identity_type && (
          <div className="row">
            <div className="col-3">Local Address Identity Proof Type</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.identity_type}</div>
          </div>
        )}

        {data?.identity_no && (
          <div className="row">
            <div className="col-3">Identity Number</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.identity_no}</div>
          </div>
        )}

        {data?.identity_file && (
          <div className="row">
            <div className="col-3">Local Address Proof File</div>
            <div className="col-1">:</div>
            <div className="col-8">
              <button
                className="btn btn-approve btn-success btn-sm"
                onClick={() => fullfileDownload(data?.identity_file)}
              >
                View Document
              </button>
            </div>
          </div>
        )}

        {data?.native_address_type && (
          <div className="row">
            <div className="col-3">Proof of Native Address</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.native_address_type}</div>
          </div>
        )}

        {data?.non_keralite_file && (
          <div className="row">
            <div className="col-3">Uploaded Proof of Native Address</div>
            <div className="col-1">:</div>
            <div className="col-8">
              <button
                className="btn btn-approve btn-success btn-sm"
                onClick={() => fullfileDownload(data?.non_keralite_file)}
              >
                View Document
              </button>
            </div>
          </div>
        )}

        {data?.fresher && (
          <div className="row">
            <div className="col-3">Fresher Status</div>
            <div className="col-1">:</div>
            <div className="col-8" style={{ textTransform: "capitalize" }}>
              {data?.fresher}
            </div>
          </div>
        )}

        {data?.name && (
          <div className="row">
            <div className="col-3">Full Name</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.name}</div>
          </div>
        )}

        {data?.dob && (
          <div className="row">
            <div className="col-3">Date of Birth</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.dob}</div>
          </div>
        )}

        {data?.gender && (
          <div className="row">
            <div className="col-3">Gender</div>
            <div className="col-1">:</div>
            <div className="col-8" style={{ textTransform: "capitalize" }}>
              {data?.gender}
            </div>
          </div>
        )}

        {data?.marital_status && (
          <div className="row">
            <div className="col-3">Marital Status</div>
            <div className="col-1">:</div>
            <div className="col-8" style={{ textTransform: "capitalize" }}>
              {data?.marital_status}
            </div>
          </div>
        )}

        {data?.parent_name && (
          <div className="row">
            <div className="col-3">Father / Spouse Name</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.parent_name}</div>
          </div>
        )}

        {data?.caste && (
          <div className="row">
            <div className="col-3">Caste Category</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.caste}</div>
          </div>
        )}

        <div className="row">
          <div className="col-3">Are you Differently Abled?</div>
          <div className="col-1">:</div>
          <div className="col-8">{data?.handicapped === 1 ? "Yes" : "No"}</div>
        </div>

        {data?.handicapped === 1 && data?.handicapped_file && (
          <div className="row">
            <div className="col-3">Disability Certificate</div>
            <div className="col-1">:</div>
            <div className="col-8">
              <button
                className="btn btn-approve btn-success btn-sm"
                onClick={() => fullfileDownload(data?.handicapped_file)}
              >
                View Certificate
              </button>
            </div>
          </div>
        )}

        {data?.address && (
          <div className="row">
            <div className="col-3">Communication Address</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.address}</div>
          </div>
        )}

        {data?.pin_code && (
          <div className="row">
            <div className="col-3">Pincode</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.pin_code}</div>
          </div>
        )}

        {data?.email && (
          <div className="row">
            <div className="col-3">Email ID</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.email}</div>
          </div>
        )}

        {data?.mobile && (
          <div className="row">
            <div className="col-3">Mobile Number</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.mobile}</div>
          </div>
        )}

        {data?.alt_email && (
          <div className="row">
            <div className="col-3">Alternate Email ID</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.alt_email}</div>
          </div>
        )}

        {data?.alt_contact && (
          <div className="row">
            <div className="col-3">Alternate / NRI Contact</div>
            <div className="col-1">:</div>
            <div className="col-8">
              {data?.alt_code && `${data?.alt_code}-`}
              {data?.alt_contact}
            </div>
          </div>
        )}

        {data?.blood_group && (
          <div className="row">
            <div className="col-3">Blood Group</div>
            <div className="col-1">:</div>
            <div className="col-8">
              {data?.blood_group === "Other" ? data?.other_blood_group : data?.blood_group}
            </div>
          </div>
        )}

        {data?.photo && (
          <div className="row">
            <div className="col-3">Uploaded Photo</div>
            <div className="col-1">:</div>
            <div className="col-8">
              <img
                src={getFileUrl(data?.photo)}
                alt="Profile"
                style={{ maxWidth: "150px", border: "1px solid #ccc", padding: "4px" }}
              />
            </div>
          </div>
        )}

        {data?.cv_upload && (
          <div className="row">
            <div className="col-3">Uploaded CV</div>
            <div className="col-1">:</div>
            <div className="col-8">
              <button
                className="btn btn-approve btn-success btn-sm"
                onClick={() => fullfileDownload(data?.cv_upload)}
              >
                View CV
              </button>
            </div>
          </div>
        )}

        {/* Education qualifications */}
        {data?.education && data?.education?.length > 0 && (
          <div className="mt-4">
            <h6 className="font-weight-bold mb-2">Educational Qualifications</h6>
            <hr />
            <div className="overflow-auto w-100">
              <CustomTable
                className="areatable"
                {...props}
                columns={[
                  { title: "Board/University", field: "university" },
                  { title: "Location", field: "location" },
                  { title: "Year of Passing", field: "year" },
                  { title: "Attainment Type", field: "edu_qualification_type" },
                  { title: "Attainment", field: "edu_qualification_text" },
                  { title: "Equivalent Percentage", field: "percentage" },
                ]}
                data={data?.education}
              />
            </div>
          </div>
        )}

        {/* Employment history */}
        {data?.employment && data?.employment?.length > 0 && (
          <div className="mt-4">
            <h6 className="font-weight-bold mb-2">Employment History</h6>
            <hr />
            <div className="row g-3">
              {data?.employment?.map((item, index) => (
                <div className="col-12 col-md-6" key={index}>
                  <div className="white p-3 border rounded shadow-sm bg-white h-100">
                    <div className="d-flex mb-1"><div className="col-4 text-muted small">Employer</div><div className="col-1">:</div><div className="col-7 font-weight-bold">{item?.employer}</div></div>
                    <div className="d-flex mb-1"><div className="col-4 text-muted small">Contact</div><div className="col-1">:</div><div className="col-7">{item?.contact}</div></div>
                    <div className="d-flex mb-1"><div className="col-4 text-muted small">Email</div><div className="col-1">:</div><div className="col-7">{item?.email}</div></div>
                    <div className="d-flex mb-1"><div className="col-4 text-muted small">Position</div><div className="col-1">:</div><div className="col-7">{item?.position}</div></div>
                    <div className="d-flex mb-1"><div className="col-4 text-muted small">Currently Working</div><div className="col-1">:</div><div className="col-7">{item?.working ? "Yes" : "No"}</div></div>
                    <div className="d-flex mb-1"><div className="col-4 text-muted small">Period</div><div className="col-1">:</div><div className="col-7">{item?.from} - {item?.to || "Till Now"}</div></div>
                    <div className="d-flex mb-1"><div className="col-4 text-muted small">Reason for Leaving</div><div className="col-1">:</div><div className="col-7">{item?.reason || "--"}</div></div>
                    <div className="d-flex mb-1"><div className="col-4 text-muted small">Address</div><div className="col-1">:</div><div className="col-7">{item?.address}</div></div>
                    {item?.exp_certificate && (
                      <div className="d-flex"><div className="col-4 text-muted small">Certificate</div><div className="col-1">:</div><div className="col-7"><button className="btn btn-approve btn-success btn-sm" onClick={() => fullfileDownload(item?.exp_certificate)}>Download</button></div></div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* References */}
        {(data?.reference_name1 || data?.reference_name2) && (
          <div className="mt-4">
            <h6 className="font-weight-bold mb-2">References</h6>
            <hr />
            <div className="row g-3">
              {data?.reference_name1 && (
                <div className="col-12 col-md-6">
                  <div className="white p-3 border rounded shadow-sm bg-white h-100">
                    <h6 className="font-weight-bold text-secondary mb-2">Reference 1</h6>
                    <div className="d-flex mb-1"><div className="col-4 text-muted small">Name</div><div className="col-1">:</div><div className="col-7 font-weight-bold">{data?.reference_name1}</div></div>
                    <div className="d-flex mb-1"><div className="col-4 text-muted small">Designation</div><div className="col-1">:</div><div className="col-7">{data?.reference_designation1}</div></div>
                    <div className="d-flex mb-1"><div className="col-4 text-muted small">Address</div><div className="col-1">:</div><div className="col-7">{data?.reference_address1}</div></div>
                    <div className="d-flex mb-1"><div className="col-4 text-muted small">Contact</div><div className="col-1">:</div><div className="col-7">{data?.ref_code_1 && `${data?.ref_code_1}-`}{data?.reference_contact1}</div></div>
                    <div className="d-flex mb-1"><div className="col-4 text-muted small">Email</div><div className="col-1">:</div><div className="col-7">{data?.reference_email1}</div></div>
                  </div>
                </div>
              )}

              {data?.reference_name2 && (
                <div className="col-12 col-md-6">
                  <div className="white p-3 border rounded shadow-sm bg-white h-100">
                    <h6 className="font-weight-bold text-secondary mb-2">Reference 2</h6>
                    <div className="d-flex mb-1"><div className="col-4 text-muted small">Name</div><div className="col-1">:</div><div className="col-7 font-weight-bold">{data?.reference_name2}</div></div>
                    <div className="d-flex mb-1"><div className="col-4 text-muted small">Designation</div><div className="col-1">:</div><div className="col-7">{data?.reference_designation2}</div></div>
                    <div className="d-flex mb-1"><div className="col-4 text-muted small">Address</div><div className="col-1">:</div><div className="col-7">{data?.reference_address2}</div></div>
                    <div className="d-flex mb-1"><div className="col-4 text-muted small">Contact</div><div className="col-1">:</div><div className="col-7">{data?.ref_code_2 && `${data?.ref_code_2}-`}{data?.reference_contact2}</div></div>
                    <div className="d-flex mb-1"><div className="col-4 text-muted small">Email</div><div className="col-1">:</div><div className="col-7">{data?.reference_email2}</div></div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {data?.interest_type && (
          <div className="row mt-4">
            <div className="col-3">Area of Interest</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.interest_type}</div>
          </div>
        )}

        {data?.expertise_area && data?.expertise_area?.length > 0 && (
          <div className="row mt-2">
            <div className="col-3">Preferences</div>
            <div className="col-1">:</div>
            <div className="col-8">
              {data?.expertise_area?.map((item, idx) => (
                <React.Fragment key={idx}>
                  {idx !== 0 && " | "}
                  {item.domain_name}
                </React.Fragment>
              ))}
              {data?.any_other_domain && ` | ${data?.any_other_domain}`}
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderVendorDetails = () => {
    return (
      <div className="dash-items-data">
        {data?.company_name && (
          <div className="row">
            <div className="col-3">Company Name</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.company_name}</div>
          </div>
        )}

        {data?.address && (
          <div className="row">
            <div className="col-3">Address</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.address}</div>
          </div>
        )}

        {data?.logo && (
          <div className="row">
            <div className="col-3">Company Logo</div>
            <div className="col-1">:</div>
            <div className="col-8">
              <button
                className="btn btn-approve btn-success btn-sm"
                onClick={() => fullfileDownload(data?.logo)}
              >
                View Logo
              </button>
            </div>
          </div>
        )}

        {data?.area_of_operation && (
          <div className="row">
            <div className="col-3">Area of Operation / Expertise</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.area_of_operation}</div>
          </div>
        )}

        {data?.company_description && (
          <div className="row">
            <div className="col-3">Brief Company Description</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.company_description}</div>
          </div>
        )}

        {data?.name && (
          <div className="row">
            <div className="col-3">Contact Person Name</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.name}</div>
          </div>
        )}

        {data?.phone_number && (
          <div className="row">
            <div className="col-3">Phone Number</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.phone_number}</div>
          </div>
        )}

        {data?.email && (
          <div className="row">
            <div className="col-3">Email</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.email}</div>
          </div>
        )}

        {data?.alternate_phone && (
          <div className="row">
            <div className="col-3">Alternate Phone</div>
            <div className="col-1">:</div>
            <div className="col-8">
              {data?.alt_country_code && `${data?.alt_country_code}-`}
              {data?.alternate_phone}
            </div>
          </div>
        )}

        {data?.alternate_email && (
          <div className="row">
            <div className="col-3">Alternate Email</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.alternate_email}</div>
          </div>
        )}

        {data?.brochure && (
          <div className="row">
            <div className="col-3">Brochure</div>
            <div className="col-1">:</div>
            <div className="col-8">
              <button
                className="btn btn-approve btn-success btn-sm"
                onClick={() => fullfileDownload(data?.brochure)}
              >
                View Brochure
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderStudentDetails = () => {
    return (
      <div className="dash-items-data">
        {data?.institution_name && (
          <div className="row">
            <div className="col-3">Institution</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.institution_name}</div>
          </div>
        )}

        {data?.full_name && (
          <div className="row">
            <div className="col-3">Full Name</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.full_name}</div>
          </div>
        )}

        {data?.email && (
          <div className="row">
            <div className="col-3">Email Address</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.email}</div>
          </div>
        )}

        {data?.phone_no && (
          <div className="row">
            <div className="col-3">Phone Number</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.phone_no}</div>
          </div>
        )}

        {data?.date_of_birth && (
          <div className="row">
            <div className="col-3">Date of Birth</div>
            <div className="col-1">:</div>
            <div className="col-8">
              {moment(data?.date_of_birth, "DD-MM-YYYY").format("DD-MM-YYYY")}
            </div>
          </div>
        )}

        {data?.gender && (
          <div className="row">
            <div className="col-3">Gender</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.gender}</div>
          </div>
        )}

        <div className="row">
          <div className="col-3">Kerala Native</div>
          <div className="col-1">:</div>
          <div className="col-8">{data?.is_kerala_native ? "Yes" : "No"}</div>
        </div>

        {data?.course_completion_status && (
          <div className="row">
            <div className="col-3">Course Completion</div>
            <div className="col-1">:</div>
            <div className="col-8" style={{ textTransform: "capitalize" }}>
              {data?.course_completion_status}
            </div>
          </div>
        )}

        {data?.address && (
          <div className="row">
            <div className="col-3">Address</div>
            <div className="col-1">:</div>
            <div className="col-8">{data?.address}</div>
          </div>
        )}

        {/* Qualifications list */}
        {data?.qualifications && data?.qualifications?.length > 0 && (
          <div className="mt-4">
            <h6 className="font-weight-bold mb-2">Educational Qualification</h6>
            {data?.qualifications?.map((qual, idx) => (
              <div key={idx} className="mb-4 p-3 border rounded shadow-sm bg-light">
                <div className="row mb-2">
                  <div className="col-12 col-md-4">
                    <b>Type:</b> {getQualificationTypeName(qual.qualification_type_id)}
                  </div>
                  <div className="col-12 col-md-4">
                    <b>Qualification:</b>{" "}
                    {getQualificationName(qual.qualification_type_id, qual.qualification_id)}
                  </div>
                  {qual.stream_id && (
                    <div className="col-12 col-md-4">
                      <b>Stream:</b>{" "}
                      {getStreamName(
                        qual.qualification_type_id,
                        qual.qualification_id,
                        qual.stream_id
                      )}
                    </div>
                  )}
                </div>
                <div className="row mb-2">
                  <div className="col-12 col-md-4">
                    <b>Board:</b> {qual.board}
                  </div>
                  <div className="col-12 col-md-4">
                    <b>Year:</b> {qual.year_passed}
                  </div>
                  <div className="col-12 col-md-4">
                    <b>Mark System:</b>{" "}
                    {qual.mark_system === "semester_gpa" ? "Semester GPA" : "Percentage"}
                  </div>
                </div>

                <div className="mt-2">
                  <h6 className="font-weight-bold mb-2" style={{ fontSize: "13px" }}>Marks Breakdown</h6>
                  <div className="table-responsive rounded overflow-hidden border">
                    <table className="table table-sm table-hover mb-0 bg-white">
                      <thead className="bg-light text-uppercase">
                        <tr style={{ fontSize: "11px", letterSpacing: "0.5px" }}>
                          <th className="px-3 py-2 border-0 fw-bold text-secondary">Period</th>
                          {qual.mark_system === "semester_gpa" ? (
                            <th className="py-2 border-0 fw-bold text-secondary text-center">CGPA</th>
                          ) : (
                            <>
                              <th className="py-2 border-0 fw-bold text-secondary text-center">
                                Marks Obtained
                              </th>
                              <th className="py-2 border-0 fw-bold text-secondary text-center">
                                Total Marks
                              </th>
                            </>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {qual.marks?.map((m, mIdx) => (
                          <tr key={mIdx} className="align-middle border-top">
                            <td className="px-3 py-2 fw-bold text-dark small">
                              {m.period_type === "semester"
                                ? `Semester ${m.period_number}`
                                : `Year ${m.period_number}`}
                            </td>
                            {qual.mark_system === "semester_gpa" ? (
                              <td className="py-2 text-center text-dark fw-bold small">{m.cgpa}</td>
                            ) : (
                              <>
                                <td className="py-2 text-center text-dark small">{m.marks_obtained}</td>
                                <td className="py-2 text-center text-dark small">{m.total_marks}</td>
                              </>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                {qual.certificate_photo && (
                  <div className="mt-2">
                    <b>Certificate:</b>{" "}
                    <button
                      className="btn btn-approve btn-success btn-sm mt-1"
                      onClick={() => fullfileDownload(qual.certificate_photo)}
                    >
                      {qual.file_name || "View Certificate"}
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        {data?.languages && data?.languages?.length > 0 && (
          <div className="row mt-3">
            <div className="col-3">Languages Known</div>
            <div className="col-1">:</div>
            <div className="col-8">
              <div className="d-flex flex-wrap gap-2">
                {data?.languages?.map((lang, i) => (
                  <span key={i} className="badge bg-light text-dark border">
                    {lang.language}
                  </span>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Selected proposals */}
        {data?.proposals && data?.proposals?.length > 0 && (
          <div className="mt-4">
            <h6 className="font-weight-bold mb-2">Internship Proposals (Selected {data?.proposals?.length})</h6>
            <div className="list-group">
              {data?.proposals?.map((prop, i) => {
                const opportunity = (data?.internshipOpportunities || []).find(
                  (o) => o.id?.toString() === prop.internship_request_id?.toString()
                );
                return (
                  <div key={i} className="list-group-item d-flex justify-content-between align-items-center bg-light border-0 rounded mb-2">
                    <div>
                      <strong>Preference #{prop.preference_order}</strong> —{" "}
                      {opportunity
                        ? opportunity.internship_discipline
                        : `Opportunity ID: ${prop.internship_request_id}`}
                      {opportunity?.brief_description && (
                        <>
                          <br />
                          <small className="text-muted">{opportunity.brief_description}</small>
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {data?.file_upload_photo && (
          <div className="row mt-3">
            <div className="col-3">Photo</div>
            <div className="col-1">:</div>
            <div className="col-8">
              <button
                className="btn btn-approve btn-success btn-sm"
                onClick={() => fullfileDownload(data?.file_upload_photo)}
              >
                View Photo
              </button>
            </div>
          </div>
        )}

        {data?.rec_letter && (
          <div className="row mt-2">
            <div className="col-3">Recommendation Letter</div>
            <div className="col-1">:</div>
            <div className="col-8">
              <button
                className="btn btn-approve btn-success btn-sm"
                onClick={() => fullfileDownload(data?.rec_letter)}
              >
                {data?.rec_letter_name || "View Letter"}
              </button>
            </div>
          </div>
        )}

        {data?.resume && (
          <div className="row mt-2">
            <div className="col-3">Resume</div>
            <div className="col-1">:</div>
            <div className="col-8">
              <button
                className="btn btn-approve btn-success btn-sm"
                onClick={() => fullfileDownload(data?.resume)}
              >
                {data?.resume_name || "View Resume"}
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  // Main UI chooser based on role
  const renderDetailsByRole = () => {
    if (loading) {
      return (
        <div className="text-center p-5">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          <p className="mt-2 text-muted">Loading profile details...</p>
        </div>
      );
    }

    const roleNum = Number(userRole);
    switch (roleNum) {
      case 0:
      case 4:
      case 5:
      case 6:
        return renderCompanyDetails();
      case 8:
        return renderAcademicDetails();
      case 9:
        return renderResourceDetails();
      case 10:
        return renderExpertDetails();
      case 20:
        return renderCandidateDetails();
      case 24:
        return renderVendorDetails();
      case 27:
        return renderStudentDetails();
      default:
        return <div className="text-muted text-center p-3">Profile details are not available for this role.</div>;
    }
  };

  return (
    <>
      <div className="dahContent-header-section">Application Details</div>
      <div className="">
        <div className="dash-datas">
          {renderDetailsByRole()}
        </div>
        {!loading && (
          <div className="d-flex justify-content-center gap-3 mt-4 mb-4">
            <button
              className="btn btn-outline-secondary"
              style={{
                borderRadius: "6px",
                padding: "8px 20px",
                fontWeight: "bold",
                minWidth: "150px",
              }}
              onClick={() => props.handleMenus("application")}
            >
              Back To Dashboard
            </button>
            {isUpdateVisible() && (
              <button
                className="btn btn-primary"
                style={{
                  borderRadius: "6px",
                  padding: "8px 20px",
                  fontWeight: "bold",
                  minWidth: "150px",
                  backgroundColor: "#28a745",
                  borderColor: "#28a745",
                }}
                onClick={handleEditProfile}
              >
                Update Profile
              </button>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default DashProfileDetails;
